import React from 'react';
import PropTypes, { number } from 'prop-types';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';

const {
  blackInBlack,
  lightGrey,
  silver,
  whiteWash,
  grey3,
} = colors;

const getHeight = appearance => {
  switch (appearance) {
    case 'extrathick':
      return 8;
    case 'thick':
      return 5;
    case 'normal':
      return 4;
    case 'semithin':
      return 3;
    case 'thin':
      return 2;
    case 'extrathin':
      return 1;
    default:
      return 4;
  }
};
/**
 * Section separator for distinction between components on a page
 */
export default function Separator({
  appearance,
  className,
  color,
  flex,
  paddingX,
  paddingY,
  paddingTop,
  paddingBottom,
  maxWidth,
  style,
}) {
  const height = getHeight(appearance);

  return (
    <Box
      className={className}
      flex={flex}
      paddingBottom={paddingBottom}
      paddingTop={paddingTop}
      paddingX={paddingX}
      paddingY={paddingY}
      maxWidth={maxWidth}
      style={style}
    >
      <Box
        color={color}
        paddingTop={height}
      />
    </Box>
  );
}

Separator.propTypes = {
  appearance: PropTypes.oneOf([
    'extrathick',
    'thick',
    'normal',
    'semithin',
    'thin',
    'extrathin',
  ]),
  className: PropTypes.string,
  color: PropTypes.oneOf([
    blackInBlack,
    silver,
    lightGrey,
    whiteWash,
    silver,
    lightGrey,
    grey3,
  ]),
  flex: PropTypes.number,
  paddingBottom: number,
  paddingTop: number,
  paddingX: number,
  paddingY: number,
  maxWidth: number,
  style: PropTypes.object,
};

Separator.defaultProps = {
  appearance: 'normal',
  className: '',
  color: blackInBlack,
  flex: undefined,
  paddingBottom: undefined,
  paddingTop: undefined,
  paddingX: undefined,
  paddingY: 8,
  maxWidth: undefined,
  style: undefined,
};
